import React from 'react'
import RaisedButton from 'material-ui-legacy/RaisedButton'
import NavigationClose from 'material-ui-legacy/svg-icons/navigation/close'

const CloseButton = (props) => (
  <RaisedButton
    style={props.style || {margin: '5px'}}
    onTouchTap={props.onTouchTap}
    label={props.label || "Close"}
    labelPosition="after"
    icon={<NavigationClose/>}
    {...props}
  />
)

export default CloseButton



// WEBPACK FOOTER //
// ./src/components/UI/CloseButton.jsx